import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { VisibleIcon, NonVisibleIcon } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Renders the button to show or hide the password input */
export function PasswordInputButton(t0) {
  const $ = _c(3);
  const {
    isVisible,
    onClick
  } = t0;
  const t1 = isVisible ? NonVisibleIcon : VisibleIcon;
  let t2;
  if ($[0] !== onClick || $[1] !== t1) {
    t2 = <SphereIconButton component={t1} onClick={onClick} color={PALETTE_VARS.text.disabled} buttonSize="24px" iconSize="18px" />;
    $[0] = onClick;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}